import { Component, OnDestroy } from '@angular/core';
import { PermissionsService } from './permissions.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { User } from 'src/app/models/user';
import { Subscription } from 'rxjs';

@Component({
  templateUrl: './settings.layout.html'
})
export class SettingsLayout implements OnDestroy {
  isLoading = true;
  private permissionsLoadedSubscription: Subscription;

  constructor(
    private authenticationService: AuthenticationService,
    private permissionService: PermissionsService) {

    this.permissionsLoadedSubscription = this.permissionService.permissionsUpdated.subscribe((loadingFinished) => {
      if (loadingFinished && this.isLoading) {
        this.isLoading = false;
      }
    })
    // setup initial Permissionsg
    this.authenticationService.currentUser.subscribe({
      next: (userData: User) => {
        this.permissionService.refreshForOrganisation(userData.organisationGuid);
      }
    });
  }
  ngOnDestroy(): void {
    if (this.permissionsLoadedSubscription) {
      this.permissionsLoadedSubscription.unsubscribe();
    }
  }
}
